import { render, staticRenderFns } from "./AttendencePage.vue?vue&type=template&id=e84b53d0&scoped=true"
import script from "./AttendencePage.vue?vue&type=script&lang=js"
export * from "./AttendencePage.vue?vue&type=script&lang=js"
import style0 from "./AttendencePage.vue?vue&type=style&index=0&id=e84b53d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84b53d0",
  null
  
)

export default component.exports